import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f72ace6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "confirmEditEmailAlumni",
  tabindex: "-1",
  "aria-labelledby": "confirmEditEmailAlumni",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "exampleModalLabel"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = {
  key: 0,
  class: "fs-7 p-3 mb-4 rounded-1 while-spaces text-erro"
}
const _hoisted_9 = { class: "text-center my-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { class: "text-center fw-bold mt-3" }
const _hoisted_12 = { class: "text-center text-break break-spaces mb-4" }
const _hoisted_13 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_14 = { class: "d-flex justify-content-center button-group" }

import { ref, onMounted } from 'vue'
import { Modal } from 'bootstrap'
import { getMessage } from '@/constants/messageCode.ts'
import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import alumnusServices from '@/services/alumnus-profile.services'

//TODO: SD45


export default /*#__PURE__*/_defineComponent({
  props: {
  email: String,
  modalConfirmEmail: Object,
},
  setup(__props) {

const props = __props

const modalComplete = ref()


const emailSame = ref<string>('')
const loading = ref(false)
const onSubmit = async (): Promise<void> => {
  // 2022/09/14 TienNV Fix double click confirm email
  loading.value = true
  const { email } = props
  try {
    const response = await alumnusServices.updateAlumniEmailApi({ email })

    if (response.status === 200) {
      props.modalConfirmEmail?.hide()
      modalComplete.value?.show()
      // 2022/09/14 TienNV Fix double click confirm email
      setTimeout(() => {
        loading.value = false
      }, 2000)
      return
      // 2022/09/14 CW-Phuong Fix for horizontal fixing#1: SD45
    } else {
      emailSame.value = response?.response?.data?.data[0]?.message_code
      loading.value = false
    }
  } catch (error: any) {
    console.log('error', error)
    loading.value = false
  }
}
const resetData = () => {
  emailSame.value = ''
}

onMounted(() => {
  modalComplete.value = new Modal(document.getElementById('editEmailAlumniComplete'))
})

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('SE45resetEmail')), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("form", {
            onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
          }, [
            (emailSame.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(getMessage)(emailSame.value)), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createTextVNode(_toDisplayString(_unref(translate)('SE45description1')), 1),
              _hoisted_10,
              _createTextVNode(_toDisplayString(_unref(translate)('SE45description2')), 1)
            ]),
            _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(translate)('SE45emailToReset')), 1),
            _createElementVNode("div", _hoisted_12, _toDisplayString(__props.email), 1),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(Button, {
                  dataBsToggle: 'modal',
                  title: _unref(translate)('titleButtonEdit'),
                  type: 'secondary',
                  className: 'me-2',
                  dataBsTarget: '#editEmailAlumni'
                }, null, 8, ["title"]),
                _createVNode(Button, {
                  type: 'secondary',
                  title: _unref(translate)('SE40sendConfirmEmail'),
                  onClick: onSubmit,
                  loading: loading.value,
                  disabled: loading.value
                }, null, 8, ["title", "loading", "disabled"])
              ])
            ])
          ], 32)
        ])
      ], 512), [
        [_directive_click_outside, resetData]
      ])
    ])
  ]))
}
}

})